module.exports = __webpack_public_path__ + "static/img/Group 7959.28a201c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/Group 7959.svg
// module id = zzAI
// module chunks = 1